import { LicenceDto } from './../../models/licenceDto';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableOptionsComponent } from "../mat-table-options/mat-table-options.component";
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareClientId } from 'src/app/services/data/companies.service';
import { OverviewCompanyDto } from 'src/app/modules/overview/models/overview-company-dto';
import { RestService } from 'src/app/services/rest.service';

interface ViewOptionsDialogData {
  guid: string;
  client: OverviewCompanyDto;
  customer: OverviewCompanyDto;
}

interface MergedLicence {
  guid: string;
  document_number: string;
  project: string;
  vrs: string;
}

@Component({
  selector: 'app-dialog-view-options',
  templateUrl: './dialog-view-options.component.html',
  styleUrl: './dialog-view-options.component.scss'
})

export class DialogViewOptionsComponent implements OnInit {
  guid = ""

  licence: LicenceDto | undefined = {} as LicenceDto
  mergedLicences: MergedLicence[] = [];

  get licenceTypeName(): string {
    const id = this.licence?.licence_type_id;
    return id ? (this.dataService.getLicenceTypeById(id)?.name ?? '') : '';
  }

  constructor(
    private dataService: DataService,
    private dialogService: DialogService,
    private shareClientId: ShareClientId,
    private restService: RestService,
    private dialogRef: MatDialogRef<DialogViewOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ViewOptionsDialogData
  ) {
    if (this.data) {
      this.dataService.getOptionsByLicence(this.data.guid as string).subscribe((options) => {
        this.shareClientId.tmpDataList = options.sort((a: any, b: any) => {
          const dateA = new Date(a.EndDate || a.end_date || 0).getTime();
          const dateB = new Date(b.EndDate || b.end_date || 0).getTime();
          if (dateA !== dateB) return dateA - dateB;
          const productIdA = (a.OptionTypeID || a.option_type_id || 0);
          const productIdB = (b.OptionTypeID || b.option_type_id || 0);
          return productIdA - productIdB;
        });
      })

      this.licence = this.dataService.getLicenceById(this.data.guid)
    }
  }

  ngOnInit(): void {
    if (this.data?.guid) {
      this.restService.get<MergedLicence[]>(`/licences/${this.data.guid}/merged`).subscribe({
        next: (list) => { this.mergedLicences = list || []; },
        error: () => {}
      });
    }
  }

  unmergeLicence(mergedGuid: string): void {
    this.restService.post<any>(`/licences/${mergedGuid}/unmerge`, {}).subscribe({
      next: () => {
        this.mergedLicences = this.mergedLicences.filter(l => l.guid !== mergedGuid);
        this.dialogRef.close(true);
      }
    });
  }
}
